import {
  LetterbookOrderOption,
} from "features/Letterbooks/types";
import {
  authorOrderOptions,
  goalOrderOptions,
  libraryOrderOptions,
  listOrderOptions,
  promptOrderOptions,
  tagOrderOptions,
  seriesOrderOptions,
  publisherOrderOptions,
  characterOrderOptions,
} from "./contexts";
import findCurrentOrder from "./findCurrentOrder";
import LetterbookTypeType from "types/LetterbookTypeType";
import { LetterbooksSerializersLetterbooks } from "types/serializers";

export interface FindOrderOptionsType {
  orderOptions: LetterbookOrderOption[];
  order: LetterbookOrderOption;
}

interface GeneratorInterface {
  [key: string]: (context: LetterbooksSerializersLetterbooks) => FindOrderOptionsType;
}

const generator: GeneratorInterface &
  Record<
    LetterbookTypeType,
    (context: LetterbooksSerializersLetterbooks) => FindOrderOptionsType
  > = {
  list: listOrderOptions,
  library: libraryOrderOptions,
  tag: tagOrderOptions,
  goal: goalOrderOptions,
  prompt: promptOrderOptions,
  author: authorOrderOptions,
  series: seriesOrderOptions,
  publisher: publisherOrderOptions,
  character: characterOrderOptions,
};

export default function findOrderOptions(
  context: LetterbooksSerializersLetterbooks
): FindOrderOptionsType {
  const { orderOptions, order } = generator[context.type](context);
  const currentOrder = findCurrentOrder(context, orderOptions);

  return {
    orderOptions,
    order: currentOrder || order,
  };
}
